import _ from 'lodash';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import CONFIG from '../config.js';
import {useWebSocket} from '../util/websocket.js';

const ID = 'host';

const Webrtc = ()=>{
    let participantPeersRef = useRef({});
    let startConnection = useCallback(async (ws, peerId)=>{
        let peer = new RTCPeerConnection({
            iceServers: [{urls: 'stun:stun.l.google.com:19302'}],
        });
        participantPeersRef.current[peerId] = {peer};
        let dataChannel = peer.createDataChannel('data');
        dataChannel.onopen = ()=>console.log("DataChannel open");
        dataChannel.onmessage = e=>console.log("Message:", e.data);
        participantPeersRef.current[peerId].dataChannel = dataChannel;
        peer.onicecandidate = ev=>{
            if (!ev.candidate)
                return;
            ws.sendEvent('signal', {to: peerId, from: ID, payload: ev.candidate});
        };
        let offer = await peer.createOffer();
        await peer.setLocalDescription(new RTCSessionDescription(offer));
        ws.sendEvent('signal', {to: peerId, from: ID, payload: offer});
        peer.ondatachannel = ev=>{
            ev.channel.onmessage = e=>console.log("Received:", e.data);
        };
    }, []);
    let sendData = useCallback(data=>{
        _.values(participantPeersRef.current).forEach(({dataChannel})=>{
            console.log('datachannel', dataChannel);
            if (dataChannel?.readyState=='open')
                dataChannel.send(data);
        });
    }, []);
    let actionMap = useMemo(()=>({
        connected: async (ws, data)=>{
            console.log('connected', data);
            let {type, id} = data;
            if (type=='participant')
                await startConnection(ws, id);
        },
        disconnected: (__, data)=>{
            console.log('disconnected', data);
            let {id, type} = data;
            if (type!='participant')
                return;
            participantPeersRef.current[id]?.peer.close();
            delete participantPeersRef.current[id];
        },
        signal: async (ws, data)=>{
            console.log('signal', data);
            let {from, payload} = data;
            let peer = participantPeersRef.current[from]?.peer;
            if (!peer)
                return;
            if (payload.type=='offer') {
                // await peer.setRemoteDescription(new RTCSessionDescription(payload));
                // let answer = await peer.createAnswer();
                // await peer.setLocalDescription(answer);
                // ws.sendEvent('signal', {to: from, from: ID, payload: answer});
            } else if (payload.type=='answer'&&!participantPeersRef.current[from].answered) {
                await peer.setRemoteDescription(new RTCSessionDescription(payload));
                participantPeersRef.current[from].answered = true;
            } else if (payload.candidate) {
                await peer.addIceCandidate(new RTCIceCandidate(payload));
            }
        },
    }), [startConnection]);
    useWebSocket({
        url: `${CONFIG.WS_URL}webrtc?type=host&id=${ID}`,
        actionMap,
        retry: true,
    });
    useEffect(()=>{
        let cb = ev=>sendData(JSON.stringify([ev.clientX, ev.clientY]));
        document.addEventListener('mousemove', cb);
        return ()=>document.removeEventListener('mousemove', cb);
    }, []);
    return null;
};

export default Webrtc;
